export default () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='2.5'
      y='4'
      width='15'
      height='12'
      rx='2'
      stroke='#5A607F'
      strokeWidth='1.5'
    />
    <path
      d='M5.5 7H14.5'
      stroke='#5A607F'
      strokeWidth='1.4'
      strokeLinecap='round'
    />
    <path
      d='M5.5 10H14.5'
      stroke='#5A607F'
      strokeWidth='1.4'
      strokeLinecap='round'
    />
    <path
      d='M5.5 13H11'
      stroke='#5A607F'
      strokeWidth='1.4'
      strokeLinecap='round'
    />
  </svg>
);
